import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'

const routes = [

  {
    path: '/id-1',
    name: 'id-1',
    meta:{ title:'宁波华然管业有限公司'},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/id-1')
  },
  {
    path: '/',
    name: 'productInfoRedict',
    meta:{ title:'宁波华然管业有限公司'},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/productInfo')
  }
  ,
  {
    path: '/productInfo',
    name: 'productInfo',
    meta:{ title:'宁波华然管业有限公司'},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/productInfo')
  },
  {
    path: '/addProduct',
    name: 'addProduct',
    meta:{ title:'宁波华然管业有限公司'},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/addProduct')
  },
  {
    path: '/hxr',
    name: 'hxr',
    meta:{ title:'宁波华然管业有限公司'},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/heart')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title
  next()
})

export default router
